export const FREDRICK_MARKET_VARIANT_MAPLELEGENDS_V1 = 'maplelegends-v1';
/**
 * MapleLegends currently disables bundle-price selling. Its Owl window still
 * labels the columns using the client vocabulary, but their market meaning is:
 *
 * - Owl `price` -> per-item market `price`
 * - Owl `bundle` -> market `units`
 * - Owl `quantity` -> preserved source evidence only
 *
 * `quantity === 1` is an observation, not a validation rule.
 */
export const mapleLegendsMarketSemantics = {
    variant: FREDRICK_MARKET_VARIANT_MAPLELEGENDS_V1,
    materializeListing(row) {
        if (!Number.isSafeInteger(row.price) || row.price < 0)
            return null;
        if (!Number.isSafeInteger(row.bundle) || row.bundle < 1)
            return null;
        return {
            price: row.price,
            units: row.bundle,
        };
    },
};
